import { databaseService } from './DatabaseService.js';

export default class UrantiaBookRangedReference {

    constructor(rawSrt) {
        this.rawSrt = rawSrt;
        
        // Break [1:2.3-7] into "1:2.3" and "7"
        const [startSrt, endSrt] = rawSrt.replace(/^\[|\]$/g, '').split('-').map(s => s?.trim());

        // Make sense of the start reference
        if (!startSrt.includes(':')) {
            // Paper number only (e.g. [10])
            this.startPaper = Number(startSrt);
            this.startSection = 0;
            this.startParagraph = 0;
            this.startSrtType = 'paper';
        } else if (!startSrt.includes('.')) {
            // Paper number and section (e.g. [1:2])
            const [paper, section] = startSrt.split(':').map(Number);
            this.startPaper = paper;
            this.startSection = section;
            this.startParagraph = 0;
            this.startSrtType = 'paper-section';
        } else {
            const matches = startSrt.match(/^(\d+):(\d+)\.(\d+)$/);
            if (matches && matches.length === 4) {
                this.startPaper = Number(matches[1]);
                this.startSection = Number(matches[2]);
                this.startParagraph = Number(matches[3]);                
                this.startSrtType = 'paper-section-paragraph';
            } else {
                // Handle invalid format
                throw new Error(`Invalid format for SRT: ${startSrt}`);
            }
        }

        // Is this not a ranged reference at all? If not, make short work of it and get out of here.
        if (!endSrt) {
            this.endSrtType = 'unspecified';
            if (this.startSrtType === 'paper') {
                this.endPaper = this.startPaper;
                this.endSection = databaseService.getNumSectionsInPaper(this.endPaper);
                this.endParagraph = databaseService.getNumParagraphsInSection(this.endPaper, this.endSection);
            } else if (this.startSrtType === 'paper-section') {
                this.endPaper = this.startPaper;
                this.endSection = this.startSection;
                this.endParagraph = databaseService.getNumParagraphsInSection(this.endPaper, this.endSection);
            } else if (this.startSrtType === 'paper-section-paragraph') {
                // Reference to a single paragraph.
                this.endPaper = this.startPaper;
                this.endSection = this.startSection;
                this.endParagraph = this.startParagraph;
            } else {
                throw new Error(`Invalid start SRT type for SRT: ${this.startSrtType}`);
            }
            return;
        }

        // Make sense of the end reference in a specified range
        throw new Error('Not implemented');

    }
    

}
